import { gql, type OperationVariables } from '@apollo/client';

import GraphQL from '../graphQL';

const query = gql`
mutation updateMyEmail($email: String!) {
    updateMyEmail(email: $email) 
},
`;

export default async function updateMyEmail(email: string) {
    const variables: OperationVariables = {
        email,
    };
    return GraphQL.mutate<boolean>(query, variables);
}
